import { apiAgent } from "../services/apiAgent";

export default {
  async getCheckoutSession(id) {
    return apiAgent.get(`stripe/get-checkout-session/${id}`);
  },
};
